var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "left-board-box" },
    [
      _c("div", { staticClass: "select-wrapper" }, [
        _c(
          "div",
          {
            staticClass: "xm-btn btn-list",
            class: _vm.currentTab == "components" ? "active" : "",
            on: {
              click: function ($event) {
                return _vm.handleClickTabs("components")
              },
            },
          },
          [_vm._v(" 题型选择 ")]
        ),
        _c(
          "div",
          {
            staticClass: "xm-btn btn-outline",
            class: _vm.currentTab == "outline" ? "active" : "",
            on: {
              click: function ($event) {
                return _vm.handleClickTabs("outline")
              },
            },
          },
          [_vm._v(" 问卷大纲 ")]
        ),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.currentTab === "outline",
              expression: "currentTab === 'outline'",
            },
          ],
          staticClass: "flex-row align-center basic-operate__box",
        },
        [
          _c(
            "el-input",
            {
              staticStyle: { "margin-right": "10px" },
              attrs: { placeholder: "搜索题目内容", clearable: "" },
              on: { input: _vm.getOutline },
              model: {
                value: _vm.titleName,
                callback: function ($$v) {
                  _vm.titleName = $$v
                },
                expression: "titleName",
              },
            },
            [
              _c("i", {
                staticClass: "el-input__icon el-icon-search",
                attrs: { slot: "prefix" },
                slot: "prefix",
              }),
            ]
          ),
          _c("i", {
            staticClass: "el-icon-more",
            on: { click: _vm.handleClickMore },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "more-operate__box", class: { active: _vm.more } },
        _vm._l(_vm.operateList, function (item) {
          return _c(
            "el-tooltip",
            {
              key: item.icon,
              attrs: {
                effect: "dark",
                content: item.content,
                placement: "top-start",
              },
            },
            [
              _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                _vm._v(_vm._s(item.content)),
              ]),
              _c(
                "span",
                {
                  staticClass: "drawing-item__primary",
                  class: item.type,
                  on: {
                    click: function ($event) {
                      return _vm.operateClick(item.type)
                    },
                  },
                },
                [_c("i", { class: item.icon })]
              ),
            ]
          )
        }),
        1
      ),
      _vm.currentTab === "outline"
        ? _c("div", { staticClass: "question_list_item description" }, [
            _c(
              "span",
              {
                staticClass: "node_question",
                class: _vm.selectItem === "description" ? "active" : "",
                on: {
                  click: function ($event) {
                    return _vm.scrollToItem($event, "description", "dId")
                  },
                },
              },
              [_vm._v("开始语")]
            ),
          ])
        : _vm._e(),
      _c(
        "el-scrollbar",
        { staticClass: "left_scrollbar" },
        [
          _c("el-row", { staticStyle: { height: "100%" } }, [
            _vm.currentTab === "components"
              ? _c(
                  "div",
                  { staticClass: "components-list" },
                  _vm._l(_vm.leftComponents, function (item, listIndex) {
                    return _c(
                      "div",
                      { key: listIndex },
                      [
                        _c("div", { staticClass: "components-title" }, [
                          _vm._v(" " + _vm._s(item.title) + " "),
                        ]),
                        _c(
                          "draggable",
                          {
                            staticClass: "components-draggable",
                            attrs: {
                              forceFallback: true,
                              clone: _vm.cloneComponent,
                              group: {
                                name: "componentsGroup",
                                pull: "clone",
                                put: false,
                              },
                              list: item.list,
                              sort: false,
                              draggable: ".components-item",
                              "force-fallback": true,
                              scroll: true,
                              "scroll-sensitivity": 160,
                            },
                            on: {
                              start: function ($event) {
                                return _vm.$emit("start")
                              },
                              move: function ($event) {
                                return _vm.$emit("move")
                              },
                              end: function (obj) {
                                _vm.$emit("end", obj)
                              },
                            },
                          },
                          _vm._l(item.list, function (element, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "components-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.addComponent($event, element)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "components-body" },
                                  [
                                    _c("form-svg-icon", {
                                      attrs: { name: element.config.tagIcon },
                                    }),
                                    _vm._v(
                                      " " + _vm._s(element.config.label) + " "
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _c(
                  "div",
                  { ref: "outline", staticClass: "outline-list" },
                  [
                    _c(
                      "draggable",
                      {
                        staticClass: "outline-list-draggable",
                        attrs: {
                          animation: 200,
                          disabled: _vm.more,
                          list: _vm.outlineData,
                          move: function (event) {
                            return _vm.$emit("move", event)
                          },
                          group: { name: "ontline_question_group" },
                          "force-fallback": true,
                          scroll: true,
                          "scroll-sensitivity": 160,
                          filter: ".group-handle,.placeholder_box",
                        },
                        on: {
                          start: function ($event) {
                            return _vm.$emit("start")
                          },
                          end: function ($event) {
                            return _vm.onGroupItemEnd($event)
                          },
                          change: function (obj) {
                            return _vm.onDraggableChange(obj, _vm.outlineData)
                          },
                        },
                      },
                      [
                        _vm._l(_vm.outlineData, function (group, groupIndex) {
                          return _c(
                            "ul",
                            {
                              key: group.formItemGroupId,
                              staticClass:
                                "question_list ontline_question_group",
                              attrs: {
                                distance: 1,
                                id: "outline_" + group.formItemGroupId,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "ontline_question_group_wrap",
                                  on: {
                                    click: function ($event) {
                                      return _vm.scrollToItem(
                                        $event,
                                        "" + group.formItemGroupId,
                                        "formItemGroupId"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "group-header text-overflow flex-row",
                                      class:
                                        _vm.selectItem === group.formItemGroupId
                                          ? "selected"
                                          : "",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "group-handle hover_cursor_pointer",
                                          on: {
                                            click: function ($event) {
                                              return _vm.toggleCollapse(
                                                $event,
                                                groupIndex,
                                                !group.collapsed
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fold-button",
                                            class: group.collapsed
                                              ? "el-icon-caret-bottom"
                                              : "el-icon-caret-right",
                                            attrs: {
                                              "caret-id": "caret-down-708",
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "hover_cursor_pointer",
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToItem(
                                                $event,
                                                "" + group.formItemGroupId,
                                                "formItemGroupId"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-folder-opened fold-button",
                                          }),
                                          _vm._v(
                                            _vm._s(group.formItemGroupName) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "draggable",
                                    {
                                      staticClass: "questions-list-draggable",
                                      attrs: {
                                        disabled: _vm.more,
                                        animation: 180,
                                        list: group.groupItems,
                                        group: {
                                          name: "outline-list-item",
                                          pull: true,
                                          put: true,
                                        },
                                        "force-fallback": true,
                                        scroll: true,
                                        "scroll-sensitivity": 160,
                                        id:
                                          "outline_question_" +
                                          group.formItemGroupId,
                                      },
                                      on: {
                                        start: function ($event) {
                                          return _vm.$emit("start")
                                        },
                                        move: function ($event) {
                                          return _vm.$emit("move")
                                        },
                                        end: function (event) {
                                          return _vm.$emit("outlineEnd", event)
                                        },
                                      },
                                    },
                                    [
                                      group.collapsed
                                        ? _vm._l(
                                            group.groupItems,
                                            function (item) {
                                              return _c(
                                                "li",
                                                {
                                                  key: item.id,
                                                  staticClass:
                                                    "question_list_item",
                                                  class:
                                                    _vm.selectItem === item.id
                                                      ? "active"
                                                      : "",
                                                  attrs: {
                                                    distance: 1,
                                                    id:
                                                      "outline_question_" +
                                                      item.id,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-overflow item-title",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.scrollToItem(
                                                            $event,
                                                            item.id,
                                                            "dId"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      !_vm.more
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "node_question",
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-document fold-button",
                                                              }),
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.title
                                                                ) + " "
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "el-checkbox",
                                                            {
                                                              attrs: {
                                                                checked:
                                                                  _vm.handleItemIds.includes(
                                                                    item.id
                                                                  ),
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.selectOutlineProject(
                                                                      $event,
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.title
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              )
                                            }
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        _c("div", { staticClass: "placeholder_box" }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
          ]),
        ],
        1
      ),
      _c("batch-rank-or-copy-dialog", {
        attrs: {
          visible: _vm.rankOrCopyVisible,
          "operation-type": _vm.operationType,
          "handle-item-ids": _vm.handleItemIds,
          "outline-data": _vm.outlineData,
        },
        on: {
          "update:visible": function ($event) {
            _vm.rankOrCopyVisible = $event
          },
          confirm: _vm.handleBatchRankOrCopyConfirm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }